/**
 * Las fotos del celular pesan 3-6 MB: se achican a 1800 px en JPEG antes de subirlas (igual que en
 * "Reportar mi pago"). Si algo falla se sube el archivo tal cual. La usan la solicitud de matrícula y la
 * Solicitud de Promoción (antes vivía dentro de preSolicitudForm.tsx).
 */
export const achicarImagen = (file: File): Promise<File> => new Promise((resolve) => {
	if (!file.type.startsWith("image/") || file.type === "image/gif") {
		resolve(file);
		return;
	}
	const url = URL.createObjectURL(file);
	const img = new Image();
	img.onload = () => {
		const escala = Math.min(1, 1800 / Math.max(img.width, img.height));
		if (escala === 1 && file.size < 1.5 * 1024 * 1024 && file.type !== "image/heic") {
			URL.revokeObjectURL(url);
			resolve(file);
			return;
		}
		const canvas = document.createElement("canvas");
		canvas.width = Math.round(img.width * escala);
		canvas.height = Math.round(img.height * escala);
		const ctx = canvas.getContext("2d");
		if (!ctx) { URL.revokeObjectURL(url); resolve(file); return; }
		ctx.fillStyle = "#fff";
		ctx.fillRect(0, 0, canvas.width, canvas.height);
		ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
		canvas.toBlob((blob) => {
			URL.revokeObjectURL(url);
			resolve(blob ? new File([blob], file.name.replace(/\.[^.]+$/, "") + ".jpg", { type: "image/jpeg" }) : file);
		}, "image/jpeg", 0.85);
	};
	img.onerror = () => { URL.revokeObjectURL(url); resolve(file); };
	img.src = url;
});

export default achicarImagen;
